module.exports = __webpack_public_path__ + "static/media/loader.61dc828e.gif";